import axios from '@/api/axios';
import type {QueryParamsInit} from '@/api/queryString';
import {toQueryString} from '@/api/queryString';
import type {
  AdminPaginatedEnvelope,
  AfriexBusinessLog,
  AfriexLogParams,
} from '@/types';

export const logService = {
  getLogList: async (
    filters: AfriexLogParams,
  ): Promise<AdminPaginatedEnvelope<AfriexBusinessLog[]>> => {
    const {tags, ...rest} = filters;
    const params: QueryParamsInit = {
      page: 0,
      limit: 10,
      ...rest,
      ...(tags?.length ? {tags: tags.join(',')} : {}),
    };
    const urlParams = toQueryString(params);
    const url = `/v2/admin/logs/telemetry?${urlParams}`;
    const response = await axios.get(url);
    return response.data as AdminPaginatedEnvelope<AfriexBusinessLog[]>;
  },
};
